import en_US from '../../date-picker/locale/en_US';
export default en_US;
//# sourceMappingURL=en_US.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/locale/en_US.js
// module id = 514
// module chunks = 0